import SpaceManager from "../Pages/SpaceManager.vue";

export default [
  {
    path: "space-manager/offer/:uuid/",
    name: "space-manager",
    component: SpaceManager,
    props: true,
    meta: {
      authenticationRequired: false,
    },
  },
];
